var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3H14V8H16V5H30C30.6 5 31 5.4 31 6V17C31 17.6 30.6 18 30 18H17V25H11.7L8 27.9V25H5C4.4 25 4 24.6 4 24V13C4 12.4 4.4 12 5 12H18V10H5C3.3 10 2 11.3 2 13V24C2 25.7 3.3 27 5 27H6V32.1L12.3 27H19V20H30C31.7 20 33 18.7 33 17V6C33 4.3 31.7 3 30 3Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 22.9H8.59995L9.19995 21.3H12.3L12.9 22.9H15.3L11.9 14H9.49995L6.19995 22.9ZM10.7 16.5L11.7 19.6H9.69995L10.7 16.5Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C21.1 17 22.6 16.7 24 16C25.4 16.7 27 17 28 17V15C28 15 27 15 25.9 14.6C27.1 13.4 28 11.6 28 9V8H25V6H23V8H20V10H25.9C25.7 11.8 24.9 12.9 24 13.6C23.4 13.1 22.8 12.4 22.4 11.5H20.3C20.7 12.8 21.3 13.8 22.1 14.6C21.1 15 20.2 15 20 15V17Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIconLight);
export default __webpack_public_path__ + "static/media/languageIconLight.0302950f8dd0a45e698a07578fa79732.svg";
export { ForwardRef as ReactComponent };